import { useMemo } from 'react';
import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_LESSON_AVAILABLE_LANGUAGES } from '../../features/lessons';
import { GET_TRACK_AVAILABLE_LANGUAGES } from '../../features/tracks';
export const useAvailableLanguages = (type = 'track', id) => {
  const isTrack = type === 'track';
  const {
    loading,
    data,
    error
  } = useQuery(GET_TRACK_AVAILABLE_LANGUAGES, {
    variables: {
      trackId: id
    },
    skip: !isTrack
  });
  const {
    loading: lessonLoading,
    data: lessonData,
    error: lessonErr
  } = useQuery(GET_LESSON_AVAILABLE_LANGUAGES, {
    variables: {
      lessonId: id.toString()
    },
    skip: isTrack
  });
  const availableLanguagesData = useMemo(() => {
    const languageData = isTrack ? data : lessonData;
    if (!languageData) return [];
    return [...languageData].sort();
  }, [data, lessonData, isTrack]);
  return {
    availableLanguagesLoading: isTrack ? loading : lessonLoading,
    availableLanguagesData,
    availableLanguagesError: isTrack ? error : lessonErr
  };
};
export const useAvailableLanguageOrFallback = ({
  trackId,
  lessonId,
  language
}) => {
  const {
    availableLanguagesData,
    availableLanguagesLoading
  } = useAvailableLanguages(trackId ? 'track' : 'lesson', trackId || lessonId);
  const languageToLoad = useMemo(() => {
    // fallback if the user requests a language that is not supported (defaults to English or the first available language)
    if (availableLanguagesData && availableLanguagesData.length && !availableLanguagesData.includes(language.toUpperCase())) {
      const lowerCasedAvailableLanguages = availableLanguagesData.map(availableLanguage => availableLanguage.toLowerCase());
      return lowerCasedAvailableLanguages.includes('en') ? 'en' : lowerCasedAvailableLanguages[0];
    }
    return language;
  }, [availableLanguagesData, language]);
  return {
    languageToLoad,
    availableLanguagesLoading,
    availableLanguagesData
  };
};
export default useAvailableLanguages;